import * as React from 'react';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { z } from 'zod';
import { TagsListPage } from '../../../features/admin/tags/components/tags-list-page';
import { PageTitleContext } from '../../__root';

// ─── Search params schema ─────────────────────────────────────

const TagsSearchSchema = z.object({
  page: z.number().int().positive().default(1).catch(1),
  pageSize: z.number().int().positive().default(25).catch(25),
  search: z.string().optional().catch(undefined),
  isActive: z.boolean().optional().catch(undefined),
});

// ─── Route ───────────────────────────────────────────────────

export const Route = createFileRoute('/admin/dictionaries/tags')({
  validateSearch: TagsSearchSchema,
  beforeLoad: ({ context }) => {
    const user = context.auth.user;
    if (!user) {
      throw redirect({ to: '/login' });
    }
  },
  component: TagsRoute,
});

function TagsRoute() {
  const { setPageTitle } = React.useContext(PageTitleContext);
  const { t } = useTranslation('inventory');

  React.useEffect(() => {
    setPageTitle(t('tags.pageTitle'));
  }, [setPageTitle, t]);

  return <TagsListPage />;
}
